// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { dashboardGroupsRequested, dashboardGroupsRequestFailed, dashboardGroupsRequestSucceeded } from './dashboard-groups.actions';
import { DashboardGroupsService } from '@coa/app/home/modules/dashboard/modules/dashboard-groups/services/dashboard-groups.service';

@Injectable()
export class DashboardGroupsEffects {

  customGroupsRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(dashboardGroupsRequested),
      mergeMap((action) => this.customGroupsService.getGroups({
        timePeriod: action.timePeriod,
        clientId: action.clientId,
        categoryId: action.categoryId,
        size: 4,
      }).pipe(
        map((customGroupsResponse) => dashboardGroupsRequestSucceeded({customGroupsResponse})),
        catchError(() => of(dashboardGroupsRequestFailed())),
      )),
    ),
  );

  constructor(
    private actions$: Actions,
    private store$: Store,
    private customGroupsService: DashboardGroupsService) {
  }
}
